module.exports = __webpack_public_path__ + "static/media/Modified Advertisement.00ee2166.pdf";